import React from 'react'

function ErrorMessage({ message }: { message: string }) {
  return (
    <p className="text-[#A80000]">{message}</p>
  )
}

export default ErrorMessage
